import { render, staticRenderFns } from "./transfer-tab.svg.vue?vue&type=template&id=c44902da&"
import script from "./transfer-tab.svg.vue?vue&type=script&lang=js&"
export * from "./transfer-tab.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports